<template>
  <div>
    <div class="search">
      <el-input placeholder="请输入专业名称" v-model="specialty_name" @keyup.enter.native="getCollege"
        class="input-with-select">
        <el-button slot="append" @click="getCollege">
          <img src="@/assets/img/home/search.png" alt="" />
        </el-button>
      </el-input>
    </div>
    <div v-if="SearchList.length > 0" class="search-list">
      <div class="search-list-content">
        <div class="search-title search-list-item color-2">已选专业：</div>
        <div class="search-list-item border-2 " v-for="(item, i) in SearchList" :key="i">
          {{ item }}
        </div>
      </div>
      <div class="toSearch search-list-item">
        <el-button size="mini" @click="onSearch">开始对比</el-button>
      </div>

    </div>

    <div class="specialty-item border-1" @click="addSpecialty(item)" v-for="(item, key) in SpecialtyList" :key="key">
      <div class="specialty-info">
        <div class="specialty-name">
          {{ item.specialty_name }} <span class="btn color-1 border-2 "
            v-if="SearchList.indexOf(item.specialty_name) > -1">
            已加入
          </span>
          <span class="btn color-1" v-else>
            +对比
          </span>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: '',
  data() {
    return {
      SpecialtyList: [],
      specialty_name: null,
      userInfo: [],
      page: {
        pageNum: 1,
        pageSize: 4,
        total: 0
      },
      SearchList: []
    };
  },
  computed: {
  },
  created() {
    this.userInfo = JSON.parse(localStorage.getItem('UserInfo'))
    this.getCollege()
  },
  methods: {
    getCollege() {
      let data = {}
      data.name = this.specialty_name
      data.pageNum = this.page.pageNum
      data.pageSize = this.page.pageSize
      data.score = this.userInfo.score
      this.$fecth.post('chat/get_specialty_list', data).then((res) => {
        this.loading = false
        this.SpecialtyList = res.lists
      })
    },
    addSpecialty(e) {
      let key = this.SearchList.indexOf(e.specialty_name)
      if (key > -1) {
        this.SearchList.splice(key, 1);
      } else {
        let splen = this.SearchList.length;
        if (splen == 3) {
          this.$alert("最多对比3个专业", "提示", {
            confirmButtonText: "确定",
          });
          return false;
        } else {
          this.SearchList.push(e.specialty_name)
        }
      }
    },
    onSearch() {
      let splen = this.SearchList.length;
      if (splen < 2) {
        this.$alert("请最少选择2个专业", "提示", {
          confirmButtonText: "确定",
        });
        return false;
      } else {
        let data = {
          title: this.SearchList.join('/'),
          specialtyList: this.SearchList,
          type: 5
        }
        this.$emit('getChat', data)
      }
    }
  },
};
</script>

<style scoped lang='less'>
.search {
  margin-bottom: 30px
}

.specialty-item {
  padding: 15px 15px;
  border-radius: 8px;
  cursor: pointer;
  margin-bottom: 10px;
  display: inline-block;
  margin-right: 20px;
}

.specialty-item:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.2);
}

.search-list {
  display: flex;
  padding-bottom: 30px;
  justify-content: space-between;

  .search-list-content {
    display: flex;

    .search-list-item {
      padding: 4px 10px;
      margin-right: 20px;
      position: relative;
      border-radius: 3px;
    }

    .search-title {
      margin-right: 0;
    }
  }
}
</style>
